import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LoadingButton } from '@/components/common/LoadingButton';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DeleteSessionDialogProps {
  open: boolean;
  itemName: string;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteSessionDialog: React.FC<DeleteSessionDialogProps> = ({
  open,
  itemName,
  isDeleting,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      {/* The MUI confirm dialog had no corner close, only the two footer
          actions, so the built-in one is hidden. */}
      <DialogContent className="revy-ui w-[calc(100%-2rem)] sm:max-w-[600px] [&>button]:hidden">
        <DialogHeader>
          <DialogTitle className="revy-cjk text-lg leading-[1.5]">
            {t('drbfm.history.deleteTitle', '分析結果を削除')}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="revy-cjk leading-[1.6]">
          {t(
            'drbfm.history.deleteConfirm',
            '「{{itemName}}」の分析結果を削除してもよろしいですか？この操作は取り消せません。',
            { itemName },
          )}
        </DialogDescription>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={onCancel} disabled={isDeleting}>
            <span className="revy-cjk">{t('common.cancel', 'キャンセル')}</span>
          </Button>
          <LoadingButton
            variant="destructive"
            onClick={onConfirm}
            loading={isDeleting}
            loadingText={t('common.deleting', '削除中...')}
          >
            <Trash2 strokeWidth={1.9} />
            <span className="revy-cjk">{t('common.delete', '削除')}</span>
          </LoadingButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteSessionDialog;
